var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWHat1MHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_headgear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "headgear_x5F_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#783C55",
    d: "M608.2,184.2c-5.5-1.4-10.9-2.9-16.3-4.7c-41.2-14.4-83.4-32.7-118.7-60C472.5,86,461,52.1,432.4,30.2 C403.7,10,368.6,10,336.6,14.3c-5.4,1-10.7,2.3-15.9,3.8c-15.7,4.7-30.4,11.7-42.9,20.8c-4.2,3.3-8.3,6.8-12.1,10.6 c-3.8,3.8-7.3,7.8-10.6,12.2c-3.2,4.5-6.1,9.2-8.7,14.2c-8.2,17.6-12.5,37.3-10.8,57.1c-31.6,44.2-86,66.5-135.9,84.8 c-4.5,1.5-9,2.9-13.5,4.3c45.1,28.7,101.7,17.1,149.4-0.6c5.2-1.7,10.5-3.4,15.7-5c21-6.6,42.1-12.6,63.6-15.5 c6.1-0.8,12.3-1.4,18.5-1.8c9.5,0.1,19,0.1,28.6,0.1c31.9,2,62.6,9.4,93.5,14.3c6.2,1,12.4,1.9,18.6,2.7 c5.2,0.7,10.4,1.3,15.7,1.8c5.3,0.4,10.7,0.7,16,0.8c38.5,1.6,79.9-8,110-33C613.4,185.4,610.8,184.8,608.2,184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F2335",
    d: "M473.2,119.5c-0.2-9.8-1.4-19.7-3.6-29.3c-5.7,0.9-11.4,1.7-17,2.4c-22.5,1.7-44.9,3.8-67.3,5.7 c-5.6,0.5-11.2,0.9-16.8,1.4c-4.2,0.2-8.4,0.4-12.6,0.6c-23.3,0.8-46.5,3.1-69.8,4.7c0.7-6.1,1.6-12.3,2.7-18.3 c1.1-5.8,2.4-11.6,4.2-17.1c9.3-25.5,30.3-48.7,56.2-56.7c-4.2,0.4-8.5,0.9-12.6,1.4c-5.4,1-10.7,2.3-15.9,3.8 c-15.7,4.7-30.4,11.7-42.9,20.8c-4.2,3.3-8.3,6.8-12.1,10.6c-3.8,3.8-7.3,7.8-10.6,12.2c-3.2,4.5-6.1,9.2-8.7,14.2 c-8.2,17.6-12.5,37.3-10.8,57.1c-31.6,44.2-86,66.5-135.9,84.8c-4.5,1.5-9,2.9-13.5,4.3c40.8,25.9,90.9,19,135.4,4.3 c2.1-1.1,4.2-2.3,6.3-3.5c9.1-5.4,17.5-12,24.8-19.6c17.4-16,24.4-36,28.2-57.3c51.3-0.9,103.4-5.6,154.6-9 c11.9-1.3,23.6-3.2,35.1-5.9c4.5-1.1,9-2.3,13.4-3.7C480.4,124.9,476.8,122.3,473.2,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M469.6,90.2c-2.7,0.4-5.4,0.9-8.2,1.2c-0.3,0-0.6,0.1-0.9,0.1c-2.7,0.4-5.3,0.7-8,1 c-22.5,1.7-44.9,3.8-67.3,5.7c-5.6,0.5-11.2,0.9-16.8,1.4c-4.2,0.2-8.4,0.4-12.6,0.6c-2.9,0.1-5.8,0.2-8.7,0.4c-0.1,0-0.2,0-0.3,0 c-2.7,0.1-5.5,0.3-8.2,0.4c-0.4,0-0.7,0-1.1,0.1c-2.3,0.1-4.6,0.3-7,0.5c-1,0.1-2,0.1-3,0.2c-1.4,0.1-2.8,0.2-4.2,0.3 c-28.8,2.1-57.6,5-86.7,4.7c-1.3,7.9-1.8,16-1.3,24.1c41,0.7,81.2-5.2,121.8-6.5c4.2-0.2,8.4-0.4,12.6-0.6 c5.6-0.4,11.2-0.9,16.8-1.4c22.4-1.9,44.8-4,67.3-5.7c6.3-0.8,12.7-1.7,19-2.7C472.5,106,471.4,98,469.6,90.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M368.5,99.7c-4.2,0.2-8.4,0.4-12.6,0.6c-2.9,0.1-5.8,0.2-8.7,0.4c-0.1,0-0.2,0-0.3,0 c-2.7,0.1-5.5,0.3-8.2,0.4c-0.4,0-0.7,0-1.1,0.1c-2.3,0.1-4.6,0.3-7,0.5c-1,0.1-2,0.1-3,0.2c-1.4,0.1-2.8,0.2-4.2,0.3 c-12.5,0.9-24.9,2-37.4,2.9c-1,8.1-1.8,16.3-2.7,24.4c24.7-1.7,49.2-4.2,73.9-5c4.2-0.2,8.4-0.4,12.6-0.6 c1.1-0.1,2.3-0.2,3.4-0.3V99.3C371.8,99.4,370.1,99.6,368.5,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#392A19",
    d: "M473,114c-0.5-8-1.5-16-3.4-23.8c-2.7,0.4-5.4,0.9-8.2,1.2c-0.3,0-0.6,0.1-0.9,0.1c-2.7,0.4-5.3,0.7-8,1 c-15.1,1.2-30.1,2.5-45.2,3.8v24.2c15.5-1.4,31-2.7,46.6-3.9C460.3,116,466.7,115.1,473,114z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.9,106.8c-1.3,7.9-1.8,16-1.3,24.1c16,0.3,32-0.5,47.8-1.5c1-8.1,1.8-16.3,2.7-24.4 C269.8,106.2,253.4,107,236.9,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8E6C45",
    d: "M385.3,98.3c-4,0.3-8,0.7-12,1v24.2c4.5-0.4,8.9-0.7,13.4-1.1c6.9-0.6,13.8-1.2,20.7-1.8V96.4 C400,97,392.7,97.7,385.3,98.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWHat1MHair1);
export default __webpack_public_path__ + "static/media/w-hat1_m-hair1.20b04b2173961291cf434e0c8a5b73bb.svg";
export { ForwardRef as ReactComponent };